import Country from '~/Api/Country/Country';

import Region from './Region';

export interface RawRegion {
	id: string;
	title: string;
	countries: { alpha2: string; name: string }[];
	subRegions: RawRegion[];
}

export default function mapRegion(region: RawRegion): Region {
	return new Region(
		region.id,
		region.title,
		region.countries.map((country) => new Country(country.alpha2, country.name)),
		region.subRegions.map(mapRegion)
	);
}
